import _ from 'lodash';
import moment from 'moment';
import BillyApi from '@/api/BillyApi';
import LoginApi from '@/api/LoginApi';
import Segment from '@/Segment';
import DDLogs from '@/DDLogs';

export const OFFERINGS = {
  ADVISORY: 'advisory',
  ADVISORY_PACKAGE: 'advisory-package',
  COUPLES: 'couples',
  ON_IT_TOGETHER_30_DAYS: '30-days',
  ON_IT_TOGETHER_100_DAYS: '100-days',
  MORTGAGE: 'mortgage',
  MORTGAGE_PARTIAL: 'mortgage-partial',
  MORTGAGE_UPGRADE: 'mortgage-upgrade',
  MORTGAGE_UPGRADE_3000: 'mortgage-upgrade_3000',
  TWO_MORTGAGE_DISCOUNT: 'two-mortgage-discount',
  MORTGAGE_COVERAGE: 'mortgage_coverage',
  MORTGAGE_COVERAGE_99: 'mortgage_coverage_99',
  MORTGAGE_PLUS: 'mortgage-plus',
  FINANCIAL_GROWTH: 'financial-growth',
  HALF_YEAR_OF_GROWTH: 'half-year-of-growth',
  ONE_YEAR_OF_GROWTH: 'one-year-of-growth',
  COMPLETION_OF_HALF_YEAR_OF_GROWTH: 'completion-of-half-year-of-growth',
  COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH: 'completion-from-half-year-of-growth-to-year-of-growth',
  COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH: 'completion-from-financial-growth-to-year-of-growth',
  ADVISORY_GROWTH_MONTH_TO_HALF_YEAR: 'advisory-growth-month-to-half-year',
  ADVISORY_GROWTH_HALF_YEAR_TO_YEAR: 'advisory-growth-half-year-to-year',
  SPECIAL_CLUB_GROWTH_MONTH_TO_HALF_YEAR: 'special-club-growth-month-to-half-year',
  SPECIAL_CLUB_GROWTH_HALF_YEAR_TO_YEAR: 'special-club-growth-half-year-to-year',
  MORTGAGE_PRE_ADVICE: 'mortgage-pre-advice',
  MORTGAGE_PARTIAL_COMPLETION: 'mortgage-partial-completion',
  MORTGAGE_COMPLETION: 'mortgage-completion',
  MORTGAGE_6800: 'mortgage-6800',
  MORTGAGE_PARTIAL_2900: 'mortgage-partial-2900',
  MORTGAGE_EXTENDED_9700: 'mortgage-extended-9700',
  MORTGAGE_PARTIAL_COMPLETION_1900: 'mortgage-partial-completion-1900',
  MORTGAGE_COMPLETION_5800: 'mortgage-completion-5800',
  MORTGAGE_COMPLETION_3900: 'mortgage-completion-3900',
  MORTGAGE_PLUS_COMPLETION_8700: 'mortgage-plus-completion-8700',
  BUNDLE_MORTGAGE_PARTIAL_GROWTH_MONTH_4550: 'bundle_mortgage-partial_advisory-growth-month_4550',
  BUNDLE_MORTGAGE_PARTIAL_GROWTH_HALF_YEAR_6165: 'bundle_mortgage-partial_advisory-growth-half-year_6165',
  BUNDLE_MORTGAGE_PARTIAL_GROWTH_YEAR_8350: 'bundle_mortgage-partial_advisory-growth-year_8350',
  BUNDLE_MORTGAGE_GROWTH_MONTH_8255: 'bundle_mortgage_advisory-growth-month_8255',
  BUNDLE_MORTGAGE_GROWTH_HALF_YEAR_9870: 'bundle_mortgage_advisory-growth-half-year_9870',
  BUNDLE_MORTGAGE_GROWTH_YEAR_12055: 'bundle_mortgage_advisory-growth-year_12055',
};

const items = {
  [OFFERINGS.ADVISORY]:
  [{
    title: 'העבודה הקשה, עלינו',
    subTitle: 'אנחנו נבנה לך תכנית ברורה שתגשים את כל המטרות שלך.',
  },
  {
    title: 'מדברים תכל׳ס',
    subTitle: 'בפגישת זום אישית נעבור יחד על התכנית וניתן לך צעדים פרקטיים כדי לצאת לדרך!',
  },
  {
    title: 'כל ההון שלך, זמין ברייזאפ',
    subTitle: 'המערכת שלנו תאסוף בשבילך את כל החסכונות, הקרנות והפקדונות שלך - כל הכספים והנכסים שנמצאים בבנק ומחוצה לו.',
  }],
  [OFFERINGS.ADVISORY_PACKAGE]:
    [{
      title: 'פגישת היכרות',
      subTitle: 'בפגישת זום נלמד להכיר אותך טוב יותר כדי להתאים לך את המשך התוכנית.',
    },
    {
      title: 'פגישת Boost',
      subTitle: 'ננתח לעומק את התזרים שלך ונזהה אפשרויות לשיפור ולחיסכון.',
    },
    {
      title: 'נגדיר את המטרות שלך לעתיד',
      subTitle: 'בעזרת שאלון ייחודי, נבין מה החלומות והיעדים שלך.',
    },
    {
      title: 'נמפה את ההון שלך בצורה אוטומטית',
      subTitle: 'ונבין מה הנכסים שאיתם אפשר להתקדם. ',
    },
    {
      title: 'פגישת זום עם יועץ כלכלי',
      subTitle: 'שיחבר בין התזרים החודשי, מיפוי ההון והיעדים, ויבנה איתך תוכנית כלכלית לשנים הבאות.',
    },
    {
      title: 'פגישת מעקב והתעדכנות',
      subTitle: 'נעזור לך לעקוב אחרי ההתקדמות, וכמה חודשים מאוחר יותר ניפגש להתעדכן ונעשה התאמות לפי הצורך.',
    }],
  [OFFERINGS.COUPLES]:
    [{
      title: 'ערכה לדייט כלכלי רומנטי',
      subTitle: 'ערכה דיגיטלית לשימוש מתי שתרצו',
    },
    {
      title: 'מופע הומוריסטי ומלמד',
      subTitle: 'בהנחיית גברת רביע, בזום, ב־25.2',
    },
    {
      title: 'הנחייה ליצירת תוכנית כלכלית זוגית',
      subTitle: 'נלמד להפוך את הכסף למטרה משותפת',
    }],
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]:
    [{
      title: 'תכנית אימון ייחודית למשך 30 יום',
      subTitle: '2 דקות ביום כדי להגיע לחסכון מיידי',
    },
    {
      title: 'תוכן ואתגרים שבועיים',
      subTitle: 'כלים וטיפים כדי לקחת את הכסף בידיים',
    },
    {
      title: 'ליווי בקבוצת וואטסאפ ייעודית',
      subTitle: 'ליווי קבוצתי מגדיל את הסיכויים להצלחה',
    }],
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]:
    [{
      title: 'תכנית אימון ייחודית למשך 100 יום',
      subTitle: '2 דקות ביום כדי להגיע לחסכון מיידי',
    },
    {
      title: 'תוכן ואתגרים שבועיים',
      subTitle: 'כלים וטיפים כדי לקחת את הכסף בידיים',
    },
    {
      title: 'ליווי בקבוצת וואטסאפ ייעודית',
      subTitle: 'ליווי קבוצתי מגדיל את הסיכויים להצלחה',
    }],
  [OFFERINGS.MORTGAGE]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_PARTIAL]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_UPGRADE]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_COVERAGE]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_COVERAGE_99]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_PLUS]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
    {
      title: 'בניית אסטרטגיה להחזר התוספת על המשכנתא',
      subTitle: 'בונים תוכנית אסטרטגית להחזר התוספת באופן המיטבי ביותר',
    },
  ],
  [OFFERINGS.FINANCIAL_GROWTH]: [
    {
      title: 'ניתוח מעמיק של התזרים',
      subTitle: '',
    },
    {
      title: 'תוכנית פיננסית מותאמת אישית למטרות ולצרכים שלכם',
      subTitle: '',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: [
    {
      title: 'תוכנית פיננסית מותאמת אישית למטרות ולצרכים שלכם',
      subTitle: 'מפגש חודשי עם יועץ אישי למעקב ועדכונים',
    },
    {
      title: 'ניתוח מעמיק של התזרים',
      subTitle: '',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: [
    {
      title: 'תוכנית פיננסית מותאמת אישית למטרות ולצרכים שלכם',
      subTitle: 'מפגש חודשי עם יועץ אישי למעקב ועדכונים',
    },
    {
      title: 'ניתוח מעמיק על התזרים',
      subTitle: '',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: [
    {
      title: 'תוכנית פיננסית מותאמת אישית למטרות ולצרכים שלכם',
      subTitle: 'מפגש חודשי עם יועץ אישי למעקב ועדכונים',
    },
    {
      title: 'ניתוח מעמיק על התזרים',
      subTitle: '',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: [
    {
      title: 'תוכנית פיננסית מותאמת אישית למטרות ולצרכים שלכם',
      subTitle: 'מפגש חודשי עם יועץ אישי למעקב ועדכונים',
    },
    {
      title: 'ניתוח מעמיק של התזרים',
      subTitle: '',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: [
    {
      title: 'תוכנית פיננסית מותאמת אישית למטרות ולצרכים שלכם',
      subTitle: 'מפגש חודשי עם יועץ אישי למעקב ועדכונים',
    },
    {
      title: 'ניתוח מעמיק על התזרים',
      subTitle: '',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: [
    {
      title: 'ניתוח מעמיק של האפשרות והתנאים ללקיחת המשכנתא',
      subTitle: '',
    },
    {
      title: 'בחינת התזרים לאור השינויים המתוכננים',
      subTitle: '',
    },
    {
      title: 'יועצים מנוסים שיענו על כל שאלה והתלבטות פיננסית לקראת הצעד הגדול',
      subTitle: '',
    },
  ],
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
  [OFFERINGS.MORTGAGE_COMPLETION]: [
    {
      title: 'אלגוריתם שבוחן אלפי אפשרויות',
      subTitle: 'ובוחר את המסלולים המדויקים בשבילך',
    },
    {
      title: 'החזר חודשי שתפור למידות שלך',
      subTitle: 'בהתאם לתזרים שלך וליכולת שלך להחזיר',
    },
    {
      title: 'יועץ אישי שידאג להכל מקצה לקצה',
      subTitle: 'ברמת השירות שגורמת לאנשים לאהוב את רייזאפ',
    },
  ],
};

const title = {
  [OFFERINGS.ADVISORY]: [
    'תכנית ייעוץ אישית',
  ],
  [OFFERINGS.ADVISORY_PACKAGE]: [
    'סדרת פגישות ייעוץ',
    'לבניית תוכנית אישית',
  ],
  [OFFERINGS.COUPLES]: [
    'זוגיות בלי חשבון',
    'תוכנית בשלושה מפגשים',
  ],
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: [
    'על זה ביחד',
    'תוכנית ליווי קבוצתית',
  ],
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: [
    'על זה ביחד',
    'תוכנית ליווי קבוצתית',
  ],
  [OFFERINGS.MORTGAGE]: [
    'משכנתא עם רייזאפ',
    'מיחזור מלא',
  ],
  [OFFERINGS.MORTGAGE_PARTIAL]: [
    'משכנתא עם רייזאפ',
    'מיחזור חלקי',
  ],
  [OFFERINGS.MORTGAGE_UPGRADE]: [
    'משכנתא עם רייזאפ',
    'השלמה למיחזור מלא',
  ],
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: [
    'משכנתא עם רייזאפ',
    'השלמה למיחזור מלא',
  ],
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: [
    'משכנתא עם רייזאפ',
    'מחזור 2 משכנתאות',
  ],
  [OFFERINGS.MORTGAGE_COVERAGE]: [
    'משכנתא עם רייזאפ',
    'ניטור משכנתאות',
  ],
  [OFFERINGS.MORTGAGE_COVERAGE_99]: [
    'משכנתא עם רייזאפ',
    'ניטור משכנתאות',
  ],
  [OFFERINGS.MORTGAGE_PLUS]: [
    'משכנתא עם רייזאפ',
    'ליווי מלא + תוספת',
  ],
  [OFFERINGS.FINANCIAL_GROWTH]: [
    'צמיחה עם רייזאפ',
    'פגישה של צמיחה',
  ],
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: [
    'צמיחה עם רייזאפ',
    'חצי שנה ביחד',
  ],
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: [
    'צמיחה עם רייזאפ',
    'שנה של צמיחה',
  ],
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: [
    'צמיחה עם רייזאפ',
    'שנה של צמיחה',
  ],
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: [
    'צמיחה עם רייזאפ',
    'חצי שנה ביחד',
  ],
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: [
    'צמיחה עם רייזאפ',
    'שנה של צמיחה',
  ],
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: [
    'משכנתא עם רייזאפ',
    'ייעוץ לקראת לקיחת משכנתא',
  ],
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: [
    'משכנתא עם רייזאפ',
    'השלמה לייעוץ ממוקד',
  ],
  [OFFERINGS.MORTGAGE_COMPLETION]: [
    'משכנתא עם רייזאפ',
    'השלמה לייעוץ מלא',
  ],
  [OFFERINGS.MORTGAGE_PLUS_COMPLETION_8700]: [
    'משכנתא עם רייזאפ',
    'השלמה משיחת ייעוץ לליווי מלא + הגדלה',
  ],
  [OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_MONTH_4550]: [
    'חבילת ייעוץ',
  ],
  [OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_HALF_YEAR_6165]: [
    'חבילת ייעוץ',
  ],
  [OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_YEAR_8350]: [
    'חבילת ייעוץ',
  ],
  [OFFERINGS.BUNDLE_MORTGAGE_GROWTH_MONTH_8255]: [
    'חבילת ייעוץ',
  ],
  [OFFERINGS.BUNDLE_MORTGAGE_GROWTH_HALF_YEAR_9870]: [
    'חבילת ייעוץ',
  ],
  [OFFERINGS.BUNDLE_MORTGAGE_GROWTH_YEAR_12055]: [
    'חבילת ייעוץ',
  ],
};

const header = {
  [OFFERINGS.ADVISORY]: [
    'רוצה להגשים',
    'חלומות?',
  ],
  [OFFERINGS.ADVISORY_PACKAGE]: [
    'שנתחיל לתכנן',
    'את העתיד שלך?',
  ],
  [OFFERINGS.COUPLES]: [
    'פרטי התוכנית',
  ],
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: [
    'פרטי התוכנית',
  ],
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: [
    'פרטי התוכנית',
  ],
  [OFFERINGS.MORTGAGE]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_PARTIAL]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_UPGRADE]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_COVERAGE]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_COVERAGE_99]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_PLUS]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.FINANCIAL_GROWTH]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: [
    'פרטי היעוץ',
  ],
  [OFFERINGS.MORTGAGE_COMPLETION]: [
    'פרטי היעוץ',
  ],
};

const subHeader = {
  [OFFERINGS.ADVISORY]: 'במחיר מיוחד ללקוחות רייזאפ!',
  [OFFERINGS.ADVISORY_PACKAGE]: '',
  [OFFERINGS.COUPLES]: '',
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: '',
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: '',
  [OFFERINGS.MORTGAGE]: '',
  [OFFERINGS.MORTGAGE_PARTIAL]: '',
  [OFFERINGS.MORTGAGE_UPGRADE]: '',
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: '',
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: '',
  [OFFERINGS.MORTGAGE_COVERAGE]: '',
  [OFFERINGS.MORTGAGE_COVERAGE_99]: '',
  [OFFERINGS.MORTGAGE_PLUS]: '',
  [OFFERINGS.FINANCIAL_GROWTH]: '',
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: '',
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: '',
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: '',
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: '',
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: '',
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: '',
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: '',
  [OFFERINGS.MORTGAGE_COMPLETION]: '',
};

const fullPriceBeforeDiscount = {
  [OFFERINGS.ADVISORY]: 950,
  [OFFERINGS.ADVISORY_PACKAGE]: 2200,
  [OFFERINGS.COUPLES]: null,
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: null,
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: null,
  [OFFERINGS.MORTGAGE]: null,
  [OFFERINGS.MORTGAGE_PARTIAL]: null,
  [OFFERINGS.MORTGAGE_UPGRADE]: null,
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: null,
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: null,
  [OFFERINGS.MORTGAGE_COVERAGE]: null,
  [OFFERINGS.MORTGAGE_COVERAGE_99]: null,
  [OFFERINGS.MORTGAGE_PLUS]: null,
  [OFFERINGS.FINANCIAL_GROWTH]: null,
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: null,
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: null,
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: null,
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: null,
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: null,
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: null,
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: null,
  [OFFERINGS.MORTGAGE_COMPLETION]: null,
};

const paymentButtonTitle = {
  [OFFERINGS.ADVISORY]: 'להמשיך',
  [OFFERINGS.ADVISORY_PACKAGE]: '',
  [OFFERINGS.COUPLES]: '',
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: '',
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: '',
  [OFFERINGS.MORTGAGE]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_PARTIAL]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_UPGRADE]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: '',
  [OFFERINGS.MORTGAGE_COVERAGE]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_COVERAGE_99]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_PLUS]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.FINANCIAL_GROWTH]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: 'לשלם ולצאת לדרך!',
  [OFFERINGS.MORTGAGE_COMPLETION]: 'לשלם ולצאת לדרך!',
};

const images = {
  [OFFERINGS.ADVISORY]: {
    landing: '/images/advisory/advisory-landing.svg',
    payment: '/images/advisory/advisory-payment.svg',
    bullet: '/images/advisory/advisory-list-item-new.svg',
  },
  [OFFERINGS.ADVISORY_PACKAGE]: {
    landing: '/images/advisory/advisory-landing.svg',
    payment: '/images/advisory/advisory-payment.svg',
    bullet: '/images/advisory/advisory-list-item-new.svg',
  },
  [OFFERINGS.COUPLES]: {
    landing: '/images/one-off-offerings/couples-landing.svg',
    payment: '/images/one-off-offerings/couples-payment.svg',
    bullet: '/images/one-off-offerings/couples-bullet.svg',
  },
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: {
    landing: '/images/one-off-offerings/30-days-landing.svg',
    payment: '/images/one-off-offerings/30-days-payment.svg',
    bullet: '/images/one-off-offerings/30-days-bullet.svg',
  },
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: {
    landing: '/images/one-off-offerings/30-days-landing.svg',
    payment: '/images/one-off-offerings/30-days-payment.svg',
    bullet: '/images/one-off-offerings/30-days-bullet.svg',
  },
  [OFFERINGS.MORTGAGE]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_PARTIAL]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_UPGRADE]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_COVERAGE]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_COVERAGE_99]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_PLUS]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.FINANCIAL_GROWTH]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
  [OFFERINGS.MORTGAGE_COMPLETION]: {
    landing: '/images/one-off-offerings/mortgage-landing.svg',
    payment: '/images/one-off-offerings/mortgage-payment.svg',
    bullet: '/images/one-off-offerings/mortgage-bullet.svg',
  },
};

const config = {
  [OFFERINGS.ADVISORY]: {
    showChat: true,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://riseup-assets.s3.eu-west-1.amazonaws.com/plan_ahead_agreement.pdf',
    shareRoute: 'advisory-plan',
    termsText: 'תנאי המסלול המלאים.',
  },
  [OFFERINGS.ADVISORY_PACKAGE]: {
    showChat: true,
    showShare: true,
    showTerms: true,
    showCallout: true,
    termsUrl: 'https://riseup-assets.s3.eu-west-1.amazonaws.com/plan_ahead_agreement.pdf',
    shareRoute: 'advisory-package',
    termsText: 'תנאי המסלול המלאים.',
  },
  [OFFERINGS.COUPLES]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://riseup-assets.s3.eu-west-1.amazonaws.com/moneymoonv2agreement.pdf',
    termsText: 'תנאי המסלול המלאים.',
  },
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: {
    showChat: false,
    showShare: false,
    showTerms: false,
    showCallout: false,
    termsUrl: '',
  },
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: {
    showChat: false,
    showShare: false,
    showTerms: false,
    showCallout: false,
    termsUrl: '',
  },
  [OFFERINGS.MORTGAGE]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_PARTIAL]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_UPGRADE]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_COVERAGE]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_COVERAGE_99]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_PLUS]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.FINANCIAL_GROWTH]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
  [OFFERINGS.MORTGAGE_COMPLETION]: {
    showChat: false,
    showShare: false,
    showTerms: true,
    showCallout: false,
    termsUrl: 'https://www.riseup.co.il/termsofuse/',
    termsText: 'תנאי השימוש בשירות ייעוץ המשכנתא',
  },
};

const variant = {
  [OFFERINGS.ADVISORY]: 'dark-blue',
  [OFFERINGS.ADVISORY_PACKAGE]: 'dark-blue',
  [OFFERINGS.COUPLES]: 'saturated-red',
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: 'blue',
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: 'blue',
  [OFFERINGS.MORTGAGE]: 'dark-green',
  [OFFERINGS.MORTGAGE_PARTIAL]: 'dark-green',
  [OFFERINGS.MORTGAGE_UPGRADE]: 'dark-green',
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: 'dark-green',
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: 'dark-green',
  [OFFERINGS.MORTGAGE_COVERAGE]: 'dark-green',
  [OFFERINGS.MORTGAGE_COVERAGE_99]: 'dark-green',
  [OFFERINGS.MORTGAGE_PLUS]: 'dark-green',
  [OFFERINGS.FINANCIAL_GROWTH]: 'dark-green',
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: 'dark-green',
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: 'dark-green',
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: 'dark-green',
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: 'dark-green',
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: 'dark-green',
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: 'dark-green',
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: 'dark-green',
  [OFFERINGS.MORTGAGE_COMPLETION]: 'dark-green',
};

const textVariant = {
  [OFFERINGS.ADVISORY]: 'saturated-red',
  [OFFERINGS.ADVISORY_PACKAGE]: 'white',
  [OFFERINGS.COUPLES]: 'white',
  [OFFERINGS.ON_IT_TOGETHER_30_DAYS]: 'white',
  [OFFERINGS.ON_IT_TOGETHER_100_DAYS]: 'white',
  [OFFERINGS.MORTGAGE]: 'white',
  [OFFERINGS.MORTGAGE_PARTIAL]: 'white',
  [OFFERINGS.MORTGAGE_UPGRADE]: 'white',
  [OFFERINGS.MORTGAGE_UPGRADE_3000]: 'white',
  [OFFERINGS.TWO_MORTGAGE_DISCOUNT]: 'white',
  [OFFERINGS.MORTGAGE_COVERAGE]: 'white',
  [OFFERINGS.MORTGAGE_COVERAGE_99]: 'white',
  [OFFERINGS.MORTGAGE_PLUS]: 'white',
  [OFFERINGS.FINANCIAL_GROWTH]: 'white',
  [OFFERINGS.HALF_YEAR_OF_GROWTH]: 'white',
  [OFFERINGS.ONE_YEAR_OF_GROWTH]: 'white',
  [OFFERINGS.COMPLETION_FROM_FINANCIAL_GROWTH_TO_YEAR_OF_GROWTH]: 'white',
  [OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH]: 'white',
  [OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH]: 'white',
  [OFFERINGS.MORTGAGE_PRE_ADVICE]: 'white',
  [OFFERINGS.MORTGAGE_PARTIAL_COMPLETION]: 'white',
  [OFFERINGS.MORTGAGE_COMPLETION]: 'white',
};

const offeringAliases = [
  { newId: OFFERINGS.MORTGAGE_6800, sourceId: OFFERINGS.MORTGAGE },
  { newId: OFFERINGS.MORTGAGE_PARTIAL_2900, sourceId: OFFERINGS.MORTGAGE_PARTIAL },
  { newId: OFFERINGS.MORTGAGE_EXTENDED_9700, sourceId: OFFERINGS.MORTGAGE },
  { newId: OFFERINGS.MORTGAGE_PARTIAL_COMPLETION_1900, sourceId: OFFERINGS.MORTGAGE_PARTIAL },
  { newId: OFFERINGS.MORTGAGE_COMPLETION_3900, sourceId: OFFERINGS.MORTGAGE },
  { newId: OFFERINGS.MORTGAGE_COMPLETION_5800, sourceId: OFFERINGS.MORTGAGE },
  { newId: OFFERINGS.MORTGAGE_PLUS_COMPLETION_8700, sourceId: OFFERINGS.MORTGAGE_PLUS },
  { newId: OFFERINGS.ADVISORY_GROWTH_MONTH_TO_HALF_YEAR, sourceId: OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH },
  { newId: OFFERINGS.ADVISORY_GROWTH_HALF_YEAR_TO_YEAR, sourceId: OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH },
  { newId: OFFERINGS.SPECIAL_CLUB_GROWTH_MONTH_TO_HALF_YEAR, sourceId: OFFERINGS.COMPLETION_OF_HALF_YEAR_OF_GROWTH },
  { newId: OFFERINGS.SPECIAL_CLUB_GROWTH_HALF_YEAR_TO_YEAR, sourceId: OFFERINGS.COMPLETION_FROM_HALF_YEAR_OF_GROWTH_TO_ONE_YEAR_OF_GROWTH },
  { newId: OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_MONTH_4550, sourceId: OFFERINGS.MORTGAGE_PARTIAL },
  { newId: OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_HALF_YEAR_6165, sourceId: OFFERINGS.MORTGAGE_PARTIAL },
  { newId: OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_YEAR_8350, sourceId: OFFERINGS.MORTGAGE_PARTIAL },
  { newId: OFFERINGS.BUNDLE_MORTGAGE_GROWTH_MONTH_8255, sourceId: OFFERINGS.MORTGAGE },
  { newId: OFFERINGS.BUNDLE_MORTGAGE_GROWTH_HALF_YEAR_9870, sourceId: OFFERINGS.MORTGAGE },
  { newId: OFFERINGS.BUNDLE_MORTGAGE_GROWTH_YEAR_12055, sourceId: OFFERINGS.MORTGAGE },
];

const bundleParts = {
  [OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_MONTH_4550]: [OFFERINGS.MORTGAGE_PARTIAL, OFFERINGS.FINANCIAL_GROWTH],
  [OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_HALF_YEAR_6165]: [OFFERINGS.MORTGAGE_PARTIAL, OFFERINGS.HALF_YEAR_OF_GROWTH],
  [OFFERINGS.BUNDLE_MORTGAGE_PARTIAL_GROWTH_YEAR_8350]: [OFFERINGS.MORTGAGE_PARTIAL, OFFERINGS.ONE_YEAR_OF_GROWTH],
  [OFFERINGS.BUNDLE_MORTGAGE_GROWTH_MONTH_8255]: [OFFERINGS.MORTGAGE, OFFERINGS.FINANCIAL_GROWTH],
  [OFFERINGS.BUNDLE_MORTGAGE_GROWTH_HALF_YEAR_9870]: [OFFERINGS.MORTGAGE, OFFERINGS.HALF_YEAR_OF_GROWTH],
  [OFFERINGS.BUNDLE_MORTGAGE_GROWTH_YEAR_12055]: [OFFERINGS.MORTGAGE, OFFERINGS.ONE_YEAR_OF_GROWTH],
};

const bundleItems = _.mapValues(bundleParts, parts => parts.map(partId => ({
  title: title[partId],
  items: items[partId],
})));

[items, title, header, subHeader, fullPriceBeforeDiscount, paymentButtonTitle, images, config, variant, textVariant]
  .forEach(map => {
    offeringAliases.forEach(({ newId, sourceId }) => {
      map[newId] = map[newId] ?? map[sourceId];
    });
  });

const state = {
  initialized: false,
  hasCustomerSession: false,
  oneOffOfferings: {},
  selectedOffering: {},
  installmentsCount: 1,
};

const getters = {
  offeringsTypes: () => OFFERINGS,
  showAdvisoryNightOffering: state => state.selectedOffering?.id === OFFERINGS.ADVISORY && moment().isBefore(moment(new Date('2024-02-16 09:00'))),
  fullPriceBeforeDiscount: state => fullPriceBeforeDiscount[state.selectedOffering?.id],
  displayItems: state => items[state.selectedOffering?.id],
  title: state => title[state.selectedOffering?.id],
  header: state => header[state.selectedOffering?.id],
  images: state => images[state.selectedOffering?.id],
  variant: state => variant[state.selectedOffering?.id],
  textVariant: state => textVariant[state.selectedOffering?.id],
  subHeader: state => subHeader[state.selectedOffering?.id],
  configs: state => config[state.selectedOffering?.id],
  paymentButtonTitle: state => paymentButtonTitle[state.selectedOffering?.id],
  bundleItems: state => bundleItems[state.selectedOffering?.id],
};

const actions = {
  async init({ state, dispatch, commit, rootState }) {
    if (!state.initialized) {
      await dispatch('getOfferings');
      if (state.hasCustomerSession && !rootState.session.authenticated) {
        await dispatch('session/initMinimal', {}, { root: true });
      }
      commit('setInitialized', true);
    }
  },
  async getOfferings({ commit }) {
    const hasCustomerSession = await LoginApi.isLoggedIn();
    commit('setHasCustomerSession', hasCustomerSession);
    const { oneOffOfferings } = hasCustomerSession
      ? await BillyApi.getOfferings()
      : await BillyApi.getOfferingsNoAuth();
    commit('setOneOffOfferings', oneOffOfferings);
  },
  async purchaseOneOffOffering({ state, commit }, { paymeToken }) {
    try {
      const { id } = state.selectedOffering;
      await BillyApi.purchaseOffering({
        token: paymeToken && paymeToken.token,
        oneOffOfferings: [{ offeringId: id, numberOfInstallments: state.installmentsCount }],
        subscriptionOfferings: [],
        bundleOfferings: [],
      });
      Segment.trackUserGot(paymeToken ? 'Advisory_Succeeded_Different_Card' : 'Advisory_Succeeded_Existing_Card', { offeringId: id });
    } catch (error) {
      DDLogs.errorBusinessEvent('Purchase one off offering failed', { error });
      throw new Error(error);
    }
  },
};

const mutations = {
  selectOffering(state, { offeringId }) {
    state.selectedOffering = _.find(state.oneOffOfferings, offering => offering.id === offeringId);
  },
  setInstallmentsCount(state, installmentsCount) {
    state.installmentsCount = installmentsCount;
  },
  setInitialized(state, initializedState) {
    state.initialized = initializedState;
  },
  setHasCustomerSession(state, hasCustomerSession) {
    state.hasCustomerSession = hasCustomerSession;
  },
  setOneOffOfferings(state, oneOffOfferings) {
    state.oneOffOfferings = oneOffOfferings;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
